<template>
  <div v-if="showUserPrice" class="card border p-2">
    <p class="text-size-small text-dark font-weight-bold mb-1">
      <i class="fas fa-times cursor-pointer mr-1" title="Cancel" @click="showUserPrice = false"></i>
      Change Customer Price
    </p>
    <input
      class="form-control form-control-sm" 
      :value="item.product.productPrice.regularPrice"
      min="0"
      @change="setUserPrice"
      type="number" 
       v-focus
    />
    <p class="text-size-small text-dark mb-0 mt-1">
      <i v-if="errorMessage" class="fas fa-exclamation-triangle text-warning mr-1"></i> {{errorMessage}}
    </p>
  </div>
</template>

<script>
  export default {
    emits: ['success', 'error'],
    data() {
      return {
        showUserPrice: false,
        errorMessage: null
      }
    },
    props: {
      item: Object
    },
    methods: {
      toggle() {
        this.showUserPrice = !this.showUserPrice
      },
      setUserPrice(e) {
        if (Number(e.target.value) > 0) {
          axios.post(this.route('products.setUserPrice', this.item.product.id), {
            user_price: e.target.value
          }).then(response => {
            if (response.data.success) {
              this.errorMessage = null
              this.$emit('success', e.target.value)
              this.showUserPrice = false
            }
            else {
              this.errorMessage = response.data.message
            }
          })
        }
      }
    },
    directives: {
      focus: {
        // directive definition
        mounted(el) {
          el.focus();
          el.select();
        }
      }
    },
  }
</script>

<style scoped>
  @media (min-width: 992px) {
    .price-box {
      max-width: 65%;
    }
  }
</style>
